<template>
	<el-dialog title="选择联系人" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body :visible.sync="dialogVisible" :show-close="false" width="1200px">
		<div slot="title" class="flex align-center justify-between">
			<div class="flex align-center">
				<span class="iconfont-lianxiren text-gray text-xxl"></span>
				<div class="margin-left-xs">
					<div class="text-bold">选择联系人</div>
					<div class="text-grey text-sm" v-if="customerInfo">{{ customerInfo.name }}</div>
				</div>
			</div>
			<el-link :underline="false" type="info" @click="closeDialog"><i class="el-icon-close text-xxl"></i></el-link>
		</div>
		<div class="flex justify-between padding-top">
			<el-form :inline="true" :model="formSearch" class="demo-form-inline" label-suffix=":">
				<el-form-item label="手机">
					<el-input v-model="formSearch.data.mobile" clearable placeholder="手机号码,精准查找" style="width: 180px;" maxlength="11"></el-input>
				</el-form-item>
				<el-form-item label="姓名"><el-input v-model="formSearch.data.name" clearable placeholder="姓名,支持模糊查询" style="width: 180px;"></el-input></el-form-item>
				<el-form-item>
					<el-button type="primary" @click="getInfoList">
						<span class="el-icon-search"></span>
						查询
					</el-button>
				</el-form-item>
			</el-form>
			<div class="">
				<el-button type="success" round @click="contacterAddShow = true">
					<span class="el-icon-plus"></span>
					<span class="margin-left-xs">新建</span>
				</el-button>
			</div>
		</div>
		<div class="border">
			<el-table :data="tableData.infos" v-loading="loading">
				<el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
				<el-table-column prop="name" align="center" label="姓名">
					<template slot-scope="scope">
						<span class="text-blue" v-if="scope.row.gender == 1">
							<span class="text-bold">{{ scope.row.name }}</span>
							<span class="cu-tag sm radius line-blue margin-left-xs">先生</span>
						</span>
						<span class="text-pink" v-else-if="scope.row.gender == 2">
							<span class="text-bold">{{ scope.row.name }}</span>
							<span class="cu-tag sm radius line-pink margin-left-xs">女士</span>
						</span>
						<span class="text-black" v-else>
							<span class="text-bold">{{ scope.row.name }}</span>
						</span>
					</template>
				</el-table-column>
				<el-table-column prop="mobile" align="center" label="手机"></el-table-column>
				<el-table-column prop="position" align="center" label="职务"></el-table-column>
				<el-table-column prop="status" align="center" label="身份">
					<template slot-scope="scope">
						<el-tag type="info" size="mini" class="margin-lr-xs" round v-for="(item, index) in scope.row.status" :key="index">{{ item }}</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="name" align="center" label="选择" width="100">
					<template slot-scope="scope">
						<el-button size="small" type="primary" plain @click="checkContacter(scope.row)" v-if="!contacterInfo || contacterInfo.id != scope.row.id">
							<span class="iconfont-xuanze"></span>
							选择
						</el-button>
						<div v-else class="text-green text-bold">
							<i class="iconfont-xuanze"></i>
							<span>已选择</span>
						</div>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="padding-top text-right">
			<el-pagination
				background
				@size-change="pageSizeChange"
				@current-change="pageChange"
				:current-page="tableData.page"
				:page-sizes="[10, 20, 50, 100]"
				:page-size="formSearch.size"
				layout="total, sizes, prev, pager, next, jumper"
				:total="tableData.total"
			></el-pagination>
		</div>
		<el-dialog
			:close-on-click-modal="false"
			:close-on-press-escape="false"
			append-to-body
			:visible.sync="dialogVisibleAdd"
			width="500px"
			:show-close="false"
			top="10vh"
		>
			<div slot="title" class="flex align-center justify-between">
				<div class="flex align-center">
					<span class="el-icon-connection text-gray text-xxl"></span>
					<div class="margin-left-xs"><div class="text-bold">添加联系人到客户</div></div>
				</div>
				<el-link :underline="false" type="info" @click="dialogVisibleAdd = false"><i class="el-icon-close text-xxl"></i></el-link>
			</div>
			<div class="padding">
				<el-form ref="formAdd" :model="formAdd" label-width="60px" label-suffix=":">
					<el-form-item label="姓名" prop="name">
						<span class="text-bold">{{ formAdd.name }}</span>
					</el-form-item>
					<el-form-item label="性别" prop="gender">
						<span class="cu-tag line-blue radius" v-if="formAdd.gender == 1">先生</span>
						<span class="cu-tag line-pink radius" v-else-if="formAdd.gender == 2">女士</span>
						<span class="cu-tag line-grey radius" v-else>未知</span>
					</el-form-item>
					<el-form-item label="手机" prop="mobile">
						<span class="text-bold text-blue">{{ formAdd.mobile }}</span>
					</el-form-item>
					<el-form-item label="职务" prop="position"><el-input v-model="formAdd.position" placeholder="在该企业内职务" autocomplete="off"></el-input></el-form-item>
					<el-form-item label="身份" prop="status">
						<el-checkbox-group v-model="formAdd.status">
							<el-checkbox label="法人"></el-checkbox>
							<el-checkbox label="股东"></el-checkbox>
							<el-checkbox label="高管"></el-checkbox>
							<el-checkbox label="财务"></el-checkbox>
						</el-checkbox-group>
					</el-form-item>
					<el-form-item label="备注" prop="remark">
						<el-input type="textarea" :autosize="{ minRows: 5, maxRows: 10 }" placeholder="备注信息" v-model="formAdd.remark"></el-input>
					</el-form-item>
				</el-form>
				<div class="border-top padding-top-lg text-right">
					<el-button @click="dialogVisibleAdd = false">清 除</el-button>
					<el-button type="primary" @click="formSubmitAdd">确 定</el-button>
				</div>
			</div>
		</el-dialog>
		<contacter-add :show="contacterAddShow" @close="contacterAddShow = false" @change="addContacter"></contacter-add>
	</el-dialog>
</template>

<script>
import contacterAdd from '@/components/contacter-add.vue';
export default {
	components: { contacterAdd },
	name: 'check-contacter',
	props: {
		show: {
			type: Boolean,
			default: () => {
				return false;
			}
		},
		customer: {
			type: Object,
			default: () => {
				return null;
			}
		},
		current: {
			type: Object,
			default: () => {
				return null;
			}
		},
		config: {
			type: Object,
			default: () => {
				return { avatarSize: 128 };
			}
		}
	},
	data() {
		return {
			cfg: {},
			customerInfo: null,
			contacterInfo: null,
			errorMsg: '',
			dialogVisible: false,
			loading: false,
			formSearch: {
				page: 1,
				size: 10,
				data: {}
			},
			tableData: {
				total: 0,
				page: 1,
				size: 10,
				infos: []
			},
			contacterAddShow: false,
			dialogVisibleAdd: false,
			loadingAdd: false,
			formAdd: {
				status: []
			}
		};
	},
	created: function() {},
	mounted() {
		this.cfg = this.config;
		this.dialogVisible = this.show;
		this.customerInfo = this.customer;
		this.contacterInfo = this.current;
	},
	methods: {
		getInfoList() {
			if(!this.customerInfo) return false;
			this.formSearch.data.customer = this.customerInfo.id;
			this.loading = true;
			this.$http.post('/server/index.php?m=components/checkContacter&a=getContacterList', this.formSearch).then(
				res => {
					this.loading = false;
					if (res.result == 'ok') {
						this.tableData = res.data;
					} else {
						this.$alert(res.msg, {
							title: '操作错误',
							type: 'error'
						});
					}
				},
				r => {
					this.loading = false;
					this.$alert('网络错误，指定的服务无法访问。', {
						title: '系统错误',
						type: 'error'
					});
				}
			);
		},
		pageChange(page) {
			this.formSearch.page = page;
			this.getInfoList();
		},
		pageSizeChange(size) {
			this.formSearch.size = size;
			this.getInfoList();
		},
		closeDialog() {
			this.dialogVisible = false;
			this.$emit('close', true);
		},
		checkContacter(data) {
			this.closeDialog();
			this.$emit('check', data);
		},
		addContacter(val) {
			this.formAdd = Object.assign(
				{
					status: []
				},
				val
			);
			this.dialogVisibleAdd = true;
		},
		formSubmitAdd() {
			this.$refs['formAdd'].validate(valid => {
				if (valid) {
					this.loadingAdd = true;
					this.formAdd.customer = this.customerInfo.id;
					this.$http.post('/server/index.php?m=components/checkContacter&a=add', this.formAdd).then(
						res => {
							this.loadingAdd = false;
							if (res.result == 'ok') {
								this.$message({
									message: '联系人新建成功',
									type: 'success'
								});
								this.dialogVisibleAdd = false;
								this.getInfoList();
							} else {
								this.$alert(res.msg, {
									title: '操作错误',
									type: 'error'
								});
							}
						},
						r => {
							this.loadingAdd = false;
							this.$alert('网络错误，指定的服务无法访问。', {
								title: '系统错误',
								type: 'error'
							});
						}
					);
				} else {
					this.$alert('请根据红色提示填写。', {
						title: '表单错误',
						type: 'error'
					});
				}
			});
		}
	},
	watch: {
		customer: function(d) {
			if(d){
				if(!this.customerInfo || d.id!=this.customerInfo.id){
					this.customerInfo = d;
					this.getInfoList();
				}
			}
			this.customerInfo = d;
			//this.getInfoList();
		},
		current: function(d) {
			this.contacterInfo = d;
		},
		show: function(d) {
			this.dialogVisible = d;
			if (this.tableData.infos.length == 0 && d) {
				this.getInfoList();
			}
		}
	}
};
</script>

<style>
.infoshow-list {
	display: flex;
	justify-content: space-between;
}
</style>
